document.addEventListener('DOMContentLoaded', () => {
    const carousel = document.querySelector('.carousel-wrapper');
    const items = document.querySelectorAll('.carousel-item');
    const prevButton = document.querySelector('.carousel-button.prev');
    const nextButton = document.querySelector('.carousel-button.next');
    let currentIndex = 0;
    let itemsPerView = 4;
    let maxIndex = items.length - itemsPerView;

    function updateButtons() {
        if (currentIndex === 0) {
            prevButton.classList.add('disabled');
            prevButton.disabled = true;
        } else {
            prevButton.classList.remove('disabled');
            prevButton.disabled = false;
        }

        if (currentIndex >= maxIndex) {
            nextButton.classList.add('disabled');
            nextButton.disabled = true;
        } else {
            nextButton.classList.remove('disabled');
            nextButton.disabled = false;
        }
    }

    function showItems(index) {
        const width = window.innerWidth;
        if (width <= 768) {
            itemsPerView = 1;
        } else if (width <= 1024) {
            itemsPerView = 2;
        } else {
            itemsPerView = 4;
        }
        maxIndex = items.length - itemsPerView;
        const itemWidthPercentage = 100 / itemsPerView;
        carousel.style.transform = `translateX(${-index * itemWidthPercentage}%)`;
        updateButtons();
    }

    prevButton.addEventListener('click', () => {
        if (currentIndex > 0) {
            currentIndex--;
            showItems(currentIndex);
        }
    });

    nextButton.addEventListener('click', () => {
        if (currentIndex < maxIndex) {
            currentIndex++;
            showItems(currentIndex);
        }
    });

    const updateCarousel = () => {
        currentIndex = 0;
        showItems(currentIndex);
    };

    window.addEventListener('resize', updateCarousel);
    updateCarousel();

    // Automatically move carousel every 5 seconds
    setInterval(() => {
        if (currentIndex < maxIndex) {
            currentIndex++;
        } else {
            currentIndex = 0; // Loop back to the first item
        }
        showItems(currentIndex);
    }, 5000); // 5 seconds interval
});
